 <template>
	<v-container class="noMargin">		
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('TRANSPORT_MODULE') !== -1">					
			<v-flex lg12>
				<div class="pageTitle">
					<h2>FACTORIES</h2>					
				</div>	
				<v-btn @click.prevent="fncAddFactory" class="elevation-5" color="info"><i class="material-icons">add</i>Create Factory</v-btn>				
				<v-btn onclick="location.reload()" class="elevation-5" color="info"><i class="material-icons">refresh</i>Reload</v-btn>
			</v-flex>
		</v-layout>		
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex'; 	

	export default {
		name: 'RoleHeader',
		data () {
			return {			
				
			}		
		  },
		methods: {
			fncAddFactory() {
				var modalDetails = { title: 'Add Factory', component: 'modal-factory-add', mstate: true, params: {} };			
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
			}
		},
		computed: {
			...mapGetters([			
				'objAuthorize'			
			])
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>